import React, { useEffect, useState } from 'react'
import {
  Create,
  TextInput,
  useTranslate,
  useNotify,
  TabbedForm,
  FormTab,
  useRedirect,
  BooleanInput,
  required,
  maxLength,
  ImageInput,
  ImageField,
  TabbedFormTabs,
} from 'react-admin'
import { Grid, Skeleton } from '@mui/material'
import { FieldArray } from './logic/ArrayInput'
import { FieldArrayProduct } from './logic/ArrayInputProduct'
import { CardCommon } from 'src/components/uiElements'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import { CardCrudBottomButtons } from 'src/components/uiElements/CRUD/CardCrudBottomButtons'
import { workUnitServices } from 'src/services/reservation/workUnit/WorkUnit.service'
import { SelectInput } from 'src/components/uiElements/fields/SelectInput'
import { paymentServices } from 'src/services/payment/Payment.service'
import { numberingServices } from 'src/services/reservation/numbering/numbering.service'
import { JsonInput } from 'src/components/uiElements/react-hook-fields/JsonInputReact'
import { Notification } from 'src/components/pages/administration/work-unit/logic/Notification'
import { AutocompleteInput } from 'src/components/uiElements/fields/AutocompleteInput'
import { FieldArrayBanner } from './logic/ArrayInputBanner'
import { bannerServices } from 'src/services/reservation/banner/Banner.service'
import { FieldArrayLanding } from './logic/ArrayInputLanding'
import { hasPermissionFunction } from 'src/helper/HasPermission'
import { PERMISSION_GET } from 'src/helper/Permission'
import { reservationServices } from 'src/services/sales/reservation/reservation.service'

export const WorkUnitCreate = (props) => {
  const translate = useTranslate()
  const notify = useNotify()
  const redirect = useRedirect()
  const [workUnitList, setWorkUnitList] = useState([])
  const [loadingWorkUnitList, setLoadingWorkUnitList] = useState(false)
  const [paymentTypeList, setPaymentTypeList] = useState([])
  const [loadingPaymentTypeList, setLoadingPaymentTypeList] = useState(false)
  const [paymentMethodList, setPaymentMethodList] = useState([])
  const [loadingPaymentMethodList, setLoadingPaymentMethodList] = useState(false)
  const [numberingList, setNumberingList] = useState([])
  const [loadingNumberingList, setLoadingNumberingList] = useState(false)
  const [basesList, setBasesList] = useState([])
  const [loadingBasesList, setLoadingBasesList] = useState(false)

  const getPaymentTypeService = async () => {
    setLoadingPaymentTypeList(true)
    try {
      const allPaymentType = await paymentServices.getAllPaymentTypes()
      if (allPaymentType) {
        setPaymentTypeList(allPaymentType)
        setLoadingPaymentTypeList(false)
        return
      }
      setLoadingPaymentTypeList(false)
    } catch (error) {
      notify(`No se encontraron medios de pago`, { type: 'error' })
      setLoadingPaymentTypeList(false)
    }
  }

  const getPaymentMethodService = async () => {
    setLoadingPaymentMethodList(true)
    try {
      const allPaymentMethod = await paymentServices.getAllPaymentMethods()
      if (allPaymentMethod) {
        allPaymentMethod.forEach(
          (elem) =>
            (elem.label = `${elem.financial_entity_relation.long_name} - ${elem.card_relation.long_name}`)
        )
        setPaymentMethodList(allPaymentMethod)
        setLoadingPaymentMethodList(false)
        return
      }
      notify(`applications not found`, { type: 'error' })
      setLoadingPaymentMethodList(false)
    } catch (error) {
      notify(`please, refresh page`, { type: 'error' })
      setLoadingPaymentMethodList(false)
    }
  }

  const getNumberingService = async () => {
    setLoadingNumberingList(true)
    try {
      const allNumbering = await numberingServices.getAll()
      if (allNumbering) {
        setNumberingList(allNumbering)
        setLoadingNumberingList(false)
        return
      }
      notify(`applications not found`, { type: 'error' })
      setLoadingNumberingList(false)
    } catch (error) {
      notify(`please, refresh page`, { type: 'error' })
      setLoadingNumberingList(false)
    }
  }

  const getBasesService = async () => {
    setLoadingBasesList(true)
    try {
      const allBases = await reservationServices.getAllAlternativeBases()
      if (allBases) {
        setBasesList(allBases.map(elem => ({ name: elem })))
        setLoadingBasesList(false)
        return
      }
      notify(`bases not found`, { type: 'error' })
      setLoadingBasesList(false)
    } catch (error) {
      notify(`please, refresh page`, { type: 'error' })
      setLoadingBasesList(false)
    }
  }

  useEffect(() => {
    ;(async () => {
      await Promise.all([
        getPaymentTypeService(),
        getPaymentMethodService(),
        getNumberingService(),
        getBasesService()
      ])
    })()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getWorkUnit = async (long_name) => {
    try {
      setLoadingWorkUnitList(true)
      const allWorkUnit = await workUnitServices.getByAll({ long_name: long_name })
      setWorkUnitList(allWorkUnit)
      setLoadingWorkUnitList(false)
    } catch (error) {
      setWorkUnitList([])
      setLoadingWorkUnitList(false)
    }
  }

  const createBannersByWorkUnit = async (workUnitId, banners) => {
    const bannersToCreate = banners.filter((elem) => elem?.banner_id && elem?.new_register)
    if (bannersToCreate.length > 0) {
      try {
        const promises = bannersToCreate.map(async (elem) => {
          delete elem.new_register
          delete elem.banner_relation
          elem.work_unit_id = workUnitId
          const response = await bannerServices.createBannerByWorkUnit(elem)
          return response;
        });

        const results = await Promise.all(promises);
        return results;
      } catch (error) {
        notify(`ra.notification.create_error_banner_by_work_unit`, {
          type: 'error'
        })
        return false
      }
    }

    return true
  }

  const createDueDateMethodByWorkUnit = async (workUnitId, due_date_method) => {
    const dueDateMethodToCreate = due_date_method.filter(
      (elem) => elem?.due_date_method_relation?.id && elem?.new_register
    )
    if (dueDateMethodToCreate.length > 0) {
      try {
        const promises = dueDateMethodToCreate.map(async (elem) => {
          elem.banner_id = elem?.due_date_method_relation?.id
          delete elem.new_register
          delete elem.due_date_method_relation
          elem.work_unit_id = workUnitId
          const response = await bannerServices.createBannerByWorkUnit(elem)
          return response
        })

        const results = await Promise.all(promises)
        return results
      } catch (error) {
        notify(`ra.notification.create_error_due_date_method_by_work_unit`, {
          type: 'error',
        })
        return false
      }
    }

    return true
  }

  const onSuccess = async (data) => {
    try {
      await createBannersByWorkUnit(data.id, data.banner_relation);
    } catch (error) {
      
    } finally {
      notify('ra.notification.created_success_femenine', {
        type: 'success',
        messageArgs: { element: translate('ra.single_entity.work-unit') },
      })
      redirect('/work-unit')
    }
  }

  const onError = () => {
    notify('ra.notification.created_error_femenine', {
      type: 'error',
      messageArgs: { element: translate('ra.single_entity.work-unit') },
    })
  }

  const transform = (data) => {
    let obj = {
      ...data,
      parent_id: data.parent?.id || null
    }

    if (data?.landing_relation?.length > 0) {
      obj?.landing_relation?.forEach(elem => {
        elem.landing_id = elem.landing_id || elem.landing_relation?.id
        delete elem.landing_relation
      })
    }

    if (data?.banner_relation?.length > 0) {
      obj?.banner_relation?.forEach(elem => {
        elem.banner_id = elem.banner_id || elem.banner_relation?.id
        delete elem.banner_relation
      })
    }

    return obj
  }

  return (
    <Create {...props} transform={transform} mutationOptions={{ onSuccess, onError }} actions={null}>
      <CardCommon title={translate('ra.title.create_workUnit')}>
        <TabbedForm
          toolbar={<CardCrudBottomButtons btnSave={true} />}
          tabs={<TabbedFormTabs variant="scrollable" scrollButtons="auto" />}
        >
          <FormTab label={translate('ra.field.main')}>
            <Grid container spacing={3}>
              <EditInputsWrap label={translate('ra.field.short_name')} required>
                <TextInput
                  source='short_name'
                  label={false}
                  fullWidth
                  validate={[
                    required(),
                    maxLength(40, translate('ra.validation.maxCharacters', { characters: 40 })),
                  ]}
                />
              </EditInputsWrap>
              <EditInputsWrap label={translate('ra.field.long_name')} required>
                <TextInput source='long_name' label={false} fullWidth validate={[required()]} />
              </EditInputsWrap>
              <EditInputsWrap label={translate('ra.field.description')} required>
                <TextInput source='description' label={false} fullWidth validate={[required()]} />
              </EditInputsWrap>
              <EditInputsWrap label={translate('ra.field.logo')}>
                <ImageInput source='logo' label={''} className='image-input'>
                  <ImageField source='src' title='title' />
                </ImageInput>
              </EditInputsWrap>
              <EditInputsWrap label={translate('ra.field.logo_voucher')}>
                    <ImageInput source='logo_voucher' label={''} className='image-input'>
                      <ImageField source='src' title='title' />
                    </ImageInput>
                  </EditInputsWrap>
              {/* <EditInputsWrap label={translate('ra.field.parent_workunit')}>
                {loadingWorkUnitList ? (
                  <Skeleton variant='rectangular' width={'100%'} height={40} />
                ) : (
                  <SelectInput
                    size='small'
                    optionsText={['short_name']}
                    fullWidth
                    label={false}
                    source='parent_id'
                    options={workUnitList}
                  />
                )}
              </EditInputsWrap> */}
              <EditInputsWrap label={translate('ra.field.parent_workunit')}>
                <AutocompleteInput
                  source='parent_id'
                  options={workUnitList}
                  loading={loadingWorkUnitList}
                  optionsText={['long_name']}
                  onSearch={getWorkUnit}
                  resetOnLoad={false}
                />
              </EditInputsWrap>
              <EditInputsWrap label={translate('ra.field.payment_types')}>
                {loadingPaymentTypeList ? (
                  <Skeleton variant='rectangular' width={'100%'} height={40} />
                ) : (
                  <SelectInput
                    size='small'
                    optionsText={['long_name']}
                    fullWidth
                    label={false}
                    source='payment_type'
                    options={paymentTypeList}
                    multiple
                  />
                )}
              </EditInputsWrap>
              <EditInputsWrap label={translate('ra.field.payment_methods')}>
                {loadingPaymentMethodList ? (
                  <Skeleton variant='rectangular' width={'100%'} height={40} />
                ) : (
                  <SelectInput
                    size='small'
                    optionsText={['label']}
                    fullWidth
                    label={false}
                    source='payment_method'
                    options={paymentMethodList}
                    multiple
                  />
                )}
              </EditInputsWrap>
              <EditInputsWrap label={translate('ra.field.numbering_client')} required>
                {loadingNumberingList ? (
                  <Skeleton variant='rectangular' width={'100%'} height={40} />
                ) : (
                  <SelectInput
                    size='small'
                    optionsText={['long_name']}
                    fullWidth
                    label={false}
                    source='client_numbering_id'
                    options={numberingList}
                    validate={[required()]}
                  />
                )}
              </EditInputsWrap>
              <EditInputsWrap label={translate('ra.field.numbering_reservation')} required>
                {loadingNumberingList ? (
                  <Skeleton variant='rectangular' width={'100%'} height={40} />
                ) : (
                  <SelectInput
                    size='small'
                    optionsText={['long_name']}
                    fullWidth
                    label={false}
                    source='reservation_numbering_id'
                    options={numberingList}
                    validate={[required()]}
                  />
                )}
              </EditInputsWrap>
              <EditInputsWrap label={translate('ra.field.json')} xs={12} md={6} lg={4}>
                <JsonInput source='config' width='auto' />
              </EditInputsWrap>
              <EditInputsWrap label={translate('ra.field.url')}>
                    <TextInput source='url' label='' fullWidth />
                  </EditInputsWrap>
              <EditInputsWrap label={translate('ra.field.state')}>
                <BooleanInput label={translate('ra.field.is_active')} source='is_active' fullWidth />
              </EditInputsWrap>
            </Grid>
          </FormTab>
          <FormTab label={translate('ra.field.currency')}>
            <Grid container spacing={3}>
              <FieldArray />
            </Grid>
          </FormTab>
          <FormTab label={translate('ra.field.product')}>
            <Grid container spacing={3}>
              <FieldArrayProduct />
            </Grid>
          </FormTab>
          {hasPermissionFunction('banner', PERMISSION_GET) && (
            <FormTab label={translate('ra.field.banner')}>
              <Grid container spacing={3}>
                <FieldArrayBanner />
              </Grid>
            </FormTab>
          )}
          {hasPermissionFunction('landing', PERMISSION_GET) && (
            <FormTab label={translate('ra.field.landing')}>
              <Grid container spacing={3}>
                <FieldArrayLanding />
              </Grid>
            </FormTab>
          )}
          <FormTab label={translate('ra.title.notification')}>
            <Grid container spacing={3}>
              <Notification />
            </Grid>
          </FormTab>
          {hasPermissionFunction('billing', 'config') && (
            <FormTab label={translate('ra.title.billing')}>
              <Grid container spacing={3}>
                <EditInputsWrap label={translate('ra.field.billing_default_base')}>
                  {loadingBasesList ? (
                    <Skeleton variant='rectangular' width={'100%'} height={40} />
                  ) : (
                    <SelectInput
                      size='small'
                      optionsText={['name']}
                      optionValue='name'
                      fullWidth
                      label={false}
                      source='billing_default_base'
                      options={basesList}
                      showSearch
                    />
                  )}
                </EditInputsWrap>
                <EditInputsWrap label={translate('ra.field.billing_alternate_base')}>
                  {loadingBasesList ? (
                    <Skeleton variant='rectangular' width={'100%'} height={40} />
                  ) : (
                    <SelectInput
                      size='small'
                      optionsText={['name']}
                      optionValue='name'
                      fullWidth
                      label={false}
                      source='billing_alternate_base.options'
                      options={basesList}
                      showSearch
                      multiple
                    />
                  )}
                </EditInputsWrap>
                <EditInputsWrap label={translate('ra.field.auto_billable')}>
                  <BooleanInput label={translate('ra.field.auto_billable')} source='auto_billable' fullWidth defaultValue={true} />
                </EditInputsWrap>
              </Grid>
            </FormTab>
          )}
        </TabbedForm>
      </CardCommon>
    </Create>
  )
}
